var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step" },
    [
      _c("h2", { staticClass: "group-title" }, [
        _vm._v("What are the details?")
      ]),
      _vm._v(" "),
      _c("app-input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|max:200",
            expression: "'required|max:200'"
          }
        ],
        attrs: {
          type: "text",
          id: "camp-name",
          name: "camp-name",
          placeholder: "e.g. Master Chef Jr",
          label: "Camp name"
        },
        model: {
          value: _vm.campName,
          callback: function($$v) {
            _vm.campName = $$v
          },
          expression: "campName"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-xl-6" },
          [
            _c("dropdown", {
              attrs: {
                label: "Instructor",
                name: "instructor-id",
                "footer-action-label": "Add new Instructor",
                "not-found-message":
                  "Oh no! We can’t find anyone with that name :|",
                "not-exists-message": "There any instructors added yet",
                "max-height": 160,
                "data-list": _vm.instructors,
                "format-callback": _vm.formatInstructor,
                "default-value":
                  _vm.instructors &&
                  _vm.instructors.find(function(instructor) {
                    return instructor.id === _vm.form.camp.instructorId
                  })
              },
              on: {
                "footer-action": _vm.openInstructorModal,
                selected: _vm.setInstructorId
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-xl-6" },
          [
            _c("dropdown", {
              attrs: {
                label: "Locations",
                name: "location-id",
                "footer-action-label": "Add new Location",
                "not-found-message":
                  "Oh no! We can’t find anything with that name :|",
                "not-exists-message": "There any locations added yet",
                "max-height": 160,
                "data-list": _vm.locationsList,
                "format-callback": _vm.formatLocation,
                "default-value":
                  _vm.locations &&
                  _vm.locations.find(function(location) {
                    return location.id === _vm.form.camp.locationId
                  })
              },
              on: {
                "footer-action": _vm.openLocationModal,
                selected: _vm.setLocationId
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "group-title mt-4" }, [
        _vm._v("Camp Description")
      ]),
      _vm._v(" "),
      _c("text-editor", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: { required: true, max: 8000 },
            expression: "{ required: true, max: 8000 }"
          }
        ],
        staticClass: "editor",
        attrs: { height: "250px", name: "description", "tag-name": "textarea" },
        on: {
          input: function($event) {
            _vm.campDescription = $event
          }
        },
        model: {
          value: _vm.campDescription,
          callback: function($$v) {
            _vm.campDescription = $$v
          },
          expression: "campDescription"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "error" }, [
        _vm._v(_vm._s(_vm.errors.first("description")))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43cab016", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43cab016","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/pages/camp-form/Step1.vue
// module id = null
// module chunks = 